export const numCellSx = {
	textAlign: "right",
	fontVariantNumeric: "tabular-nums",
};
export const centerSx = { textAlign: "center" };
export const dimSx = { color: "text.disabled" };

export { formatLength } from "@/shared/utils/length";

// Bundle weight (tons) derived from the section's weight per foot:
// tons = LBsPerFoot * (LengthInches / 12) * pieces / 2000.
// Returns null when it cannot be computed (no LBsPerFoot, or non-positive
// length), so callers can fall back to a stored/manual value.
export const computeTotalWeight = (
	lbsPerFoot: number | null | undefined,
	lengthInches: number | null | undefined,
	pieces: number | null | undefined,
): number | null => {
	if (lbsPerFoot == null || !lengthInches || lengthInches <= 0) return null;
	const tons = (lbsPerFoot * (lengthInches / 12) * (pieces ?? 0)) / 2000;
	return Math.round(tons * 100) / 100;
};

// Format a bundle weight (tons) with exactly two decimals (e.g. 0.2 -> "0.20").
export const formatWeight = (weight: number): string =>
	weight.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
